export const AUTH_URL = {
    login: _.env('API_USER_LOGIN', '/company/login'),
    register: _.env('API_USER_REGISTER', '/company/register'),
    logout: _.env('API_USER_LOGOUT', '/company/logout'),
    me: _.env('API_USER_INFO', '/company/me'),
    re_password: _.env('API_USER_REPASSWORD', '/company/re-password'),
    change_password: _.env('API_USER_CHANGE_PASSWORD', '/company/change-password'),
    activeAcount: _.env('API_USER_ACTIVE_ACCOUNT', '/company/active-account'),
    editProfile: '/company/profile/edit',
    detailProfile: '/company/profile/detail',
    changeEmail: '/company/confirm/change-mail',
    forgetPassword: '/company/forget-password',
    changePassword: '/company/change-password',
    checkTokenTime: '/company/check-token',
}

export const MUTATION_TYPE = {
    unsubscribeToken: 'UNSUBSCRIBE_TOKEN',
    updateManagerInfo: 'UPDATE_USER_INFO',
    updateLoginStatus: 'UPDATE_LOGIN_STATUS',
    updateToken: 'UPDATE_TOKEN'
}
